import Axios from "axios";

export const REQUEST_PARTIDAS = "REQUEST_PARTIDAS";

export function requestPartidas(filter) {
  return {
    type: REQUEST_PARTIDAS,
    payload: filter
  };
}

export const RECEIVE_PARTIDAS = "RECEIVE_PARTIDAS";

function receivePartidas(json) {
  return {
    type: RECEIVE_PARTIDAS,
    partidas: json.data,
    receivedAt: Date.now()
  };
}

export function fetchPartidas() {
  return function(dispatch) {
    dispatch(requestPartidas());
    return fetch("http://190.105.227.203/bayervr/partidas/")
      .then(
        response => response.json(),
        // Do not use catch, because that will also catch
        // any errors in the dispatch and resulting render,
        // causing a loop of 'Unexpected batch number' errors.
        // https://github.com/facebook/react/issues/6895
        error => console.log("An error occurred.", error)
      )
      .then(json =>
        // We can dispatch many times!
        // Here, we update the app state with the results of the API call.
        dispatch(receivePartidas(json))
      );
  };
}

export function reiniciarPartidas() {
  return function(dispatch) {
    dispatch(requestPartidas());
    return Axios.post("http://190.105.227.203/bayervr/partidas/reiniciar")
      .then(
        //response => response.json(),
        // Do not use catch, because that will also catch
        // any errors in the dispatch and resulting render,
        // causing a loop of 'Unexpected batch number' errors.
        // https://github.com/facebook/react/issues/6895
        error => console.log("An error occurred.", error)
      )
      .then(json => dispatch(fetchPartidas(json)));
  };
}
